// @flow

import DND_STATES from 'components/DNDOverlay/states';

export const DND_OVERLAY_SET_IS_DRAGGING = 'dndOverlay/SET_IS_DRAGGING';
export const DND_OVERLAY_SET_DND_STATE = 'dndOverlay/SET_DND_STATE';
export const DND_OVERLAY_SET_BUTTON_VISIBLE = 'dndOverlay/SET_BUTTON_VISIBLE';

export function dndOverlaySetIsDragging(isDragging: boolean) {
  return {
    type: DND_OVERLAY_SET_IS_DRAGGING,
    isDragging,
  };
}

export function dndOverlaySetDndState(dndState: ?$Keys<typeof DND_STATES>) {
  return {
    type: DND_OVERLAY_SET_DND_STATE,
    dndState,
  };
}

export function dndOverlaySetButtonVisible(buttonVisible: boolean) {
  return {
    type: DND_OVERLAY_SET_BUTTON_VISIBLE,
    buttonVisible,
  };
}



// WEBPACK FOOTER //
// ./actions/dndOverlay.js